
import { Component, Vue } from 'vue-property-decorator';

import Form16ProcessHeader from "@/components/process/Form16/components/Form16ProcessHeader.vue";
import Form16CaseInformation from "@/components/process/Form16/components/Form16CaseInformation.vue";
import { form16StatusInfoType } from '@/types/Information/Form16';

@Component({
    components:{
        Form16ProcessHeader,
        Form16CaseInformation
    }
})
export default class StartForm16 extends Vue {

    stepsCompleted = {} as form16StatusInfoType;   

    mounted() {  
        this.stepsCompleted = {
            first: false,
            second: false,
            third: false
        }       
    }  


}
